export default defineNuxtPlugin((nuxtApp) => {

  const route = useRoute()
  const preview =
    Boolean(route.query?._storyblok) ||
    Boolean(route.query?.['_storyblok_tk[space_id]'])
 
  if (preview) {
    nuxtApp.hook('page:finish', () => { 
      //refreshNuxtData() 
    })
  }
 
  return { 
    provide: { preview }
  }

})
